<template>
  <div>
    <div class="panel-body">
      
        <div class="panel-body">
          <h4>Drilling Parameters</h4>
        <div class="d-flex flex-row-reverse">
          <b-button-group v-if="editable"> 
            <div>
            <DxButton
              icon="download"
              hint="Download Drilled Section excel file"
              :height="40"
              @click="downloadContigencyTemplate"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshGrid" />
          </div>
          

            <!-- DxFileUploader
            ref="fileUploader"
            accept=".xlss, .xls"
            upload-mode="instantly"
            :upload-url="uploadUrl"
            :upload-headers="uploadHeaders"
            :visible="false"
            / -->

            <file-upload
              v-model="files"
              extensions="xlsx"
              accept=".xlsx"
              style="cursor: pointer"
              :multiple="false"
              @input-filter="inputFilter"
              @input-file="inputFile"
            >
            <DxButton
            id="upload-button"
            icon="upload"
            hint="Upload data in spreadsheet file"
            :height="40" />
            <!-- @click="uploadClick" />    
              < b-button
                class="btn btn-sm"
                variant="outline-primary"
                size="sm"
                >Add
              </b-button -->
            </file-upload >
          </b-button-group>
        </div>
        </div>
      <!-- /b-form -->
    </div>
    <br/>
    <b-alert v-if="dataHasNotBeenUploaded && editable" show variant="info">
    <p>
      The drilling parameters for this daily report has not been uploaded.
    </p>
    <p>
      Please make sure the file size is less than 2 MB.<br/>
      You can let the uploading process done in the background and do other works.
    </p>
    
    </b-alert>
    <b-alert  v-if="fileUpload !== null" show variant="primary">
      <b-row align-h="between">
        <b-col cols="6">
          <p>
          File {{ fileNameUpload }} is ready to upload. <br/>
          </p>
        </b-col>
        <b-col cols="6"> 
          <b-button class="btn btn-sm" variant="outline-primary" size="sm" @click="submitFile">
            Upload Now
          </b-button>
        </b-col>
      </b-row>
    </b-alert>
    <b-alert v-show="editable && uploadData.jobStatus < 100">
      <p>Your file has been uploaded. It is being processed...</p> 
          <DxProgressBar :value="uploadData.jobStatus" :show-status=true />
    </b-alert>
    <div class="overflow-auto">
      <DxDataGrid
        id="report-grid"
        ref="reportGrid"
          :data-source="uploadsDataSource"
          :show-borders="false"
          :show-column-lines="false"
          :show-row-lines="true"
          column-resize-mode="nextColumn"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :cell-hint-enabled="true"
          :word-wrap-enabled="true"
          :remote-operations="false"
          width="100%"
          :height="300"
          @selection-changed="selectionChanged"
          @editing-start="onEditingStart"
        >
        <DxPaging :enabled="false"/>
        <DxScrolling column-rendering-mode="virtual"/>
        <DxSelection mode="none" />
        <DxEditing
          :allow-updating="false"
          :allow-adding="false"
          :allow-deleting="false && (!dataHasNotBeenUploaded && editable)"
          :use-icons="true"
          mode="row"
        />
        <DxColumn data-field="no" data-type="number" caption="Report No." width="100" />
        <DxColumn data-field="minDepth" data-type="number" caption="Starting Depth" width="200" />
        <DxColumn data-field="maxDepth" data-type="number" caption="Final Depth" width="200" />
        <DxColumn data-field="updatedAt" data-type="date" caption="Upload Date" />
        <DxColumn data-field="updatedBy" data-type="text" caption="Updated By" />
      </DxDataGrid>
      <div>  <!-- v-show="canEdit" -->
        <p><span >Details on current report </span>
        
          <DxButton
              text="Delete all"
              hint="Delete all survey data in this report"
              styling-mode="text"
              :height="40"
              @click="deleteAll"
              />
        </p>
        <DxDataGrid
          id="report-details-grid"
          ref="reportDetailsGrid"
            :data-source="drillingParametersDataSource"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="true"
            width="100%"
            :height="500"
            :remote-operations="true"
            @row-inserted="rowInserted"
            @row-updated="rowUpdated"
            @row-removed="rowRemoved"
            @editing-start="onEditingStart"
          >
          <DxPaging :enabled="false" :page-size="20" />
          <DxScrolling mode="virtual" column-rendering-mode="virtual"/>
          <DxEditing
            :allow-updating="canEdit"
            :allow-adding="canEdit"
            :allow-deleting="canEdit"
            :use-icons="true"
            mode="row"
          />
          <DxColumn
              type="buttons"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
          <!-- DxColumn caption="No." :calculate-cell-value="setReportNo"  width="70" :visible="false" >
            <DxFormItem :visible="false"/>
          </DxColumn -->

          <DxColumn data-field="depth" data-type="number" caption="Depth" />
          <DxColumn data-field="tvd" data-type="number" caption="TVD" />
          <DxColumn data-field="rop" data-type="number" caption="ROP" />
          <DxColumn data-field="ropMin" data-type="number" caption="ROP Min" />
          <DxColumn data-field="ropMax" data-type="number" caption="ROP Max" />
          <DxColumn data-field="wob" data-type="number" caption="WOB" />
          <DxColumn data-field="wobMin" data-type="number" caption="WOB Min" />
          <DxColumn data-field="wobMax" data-type="number" caption="WOB Max" />
          <DxColumn data-field="woh" data-type="number" caption="WOH" />
          <DxColumn data-field="hkHeight" data-type="number" caption="HK Height" />
          <DxColumn data-field="rpm" data-type="number" caption="RPM" />
          <DxColumn data-field="dhRpm" data-type="number" caption="DH RPM" />
          <DxColumn data-field="totalRpm" data-type="number" caption="Total RPM" />
          <DxColumn data-field="flowIn" data-type="number" caption="Flow In" />
          <DxColumn data-field="flowInMin" data-type="number" caption="Flow In Min" />
          <DxColumn data-field="flowInMax" data-type="number" caption="Flow In Max" />
          <DxColumn data-field="pump1" data-type="number" caption="Pump 1" />
          <DxColumn data-field="pump2" data-type="number" caption="Pump 2" />
          <DxColumn data-field="pump3" data-type="number" caption="Pump 3" />
          <DxColumn data-field="spp" data-type="number" caption="SPP" />
          <DxColumn data-field="sppMin" data-type="number" caption="SPP Min" />
          <DxColumn data-field="sppMax" data-type="number" caption="SPP Max" />
          <DxColumn data-field="torque" data-type="number" caption="Torque" />
          <DxColumn data-field="torqueMin" data-type="number" caption="Torque Min" />
          <DxColumn data-field="torqueMax" data-type="number" caption="Torque Max" />
          <DxColumn data-field="flowReturns" data-type="number" caption="Flow Returns" />
          <DxColumn data-field="adaReturn" data-type="number" caption="ADA Return" />
          <DxColumn data-field="tempIn" data-type="number" caption="Temp In" />
          <DxColumn data-field="tempOut" data-type="number" caption="Temp Out" />
          <DxColumn data-field="mwIn" data-type="number" caption="MW In" />
          <DxColumn data-field="mwOut" data-type="number" caption="MW Out" />
          <DxColumn data-field="condIn" data-type="number" caption="Cond In" />
          <DxColumn data-field="condOut" data-type="number" caption="Cond Out" />
          <DxColumn data-field="interm1" data-type="number" caption="Inter M1" />
          <DxColumn data-field="interm2a" data-type="number" caption="Inter M2a" />
          <DxColumn data-field="active" data-type="number" caption="Active" />
          <DxColumn data-field="reserve1" data-type="number" caption="Reserve 1" />
          <DxColumn data-field="sumActive" data-type="number" caption="Sum Active" />
          <DxColumn data-field="bitTime" data-type="number" caption="Bit Time" />
          <DxColumn data-field="pumpTime" data-type="number" caption="Pump Time" />
          <DxColumn data-field="revOnBottom" data-type="number" caption="Rev On Bottom" />
          <DxColumn data-field="co2" data-type="number" caption="CO2" />
          <DxColumn data-field="h2sLine" data-type="number" caption="H2S Line" />
          <DxColumn data-field="h2sShaker" data-type="number" caption="H2S Shaker" />
          <DxColumn data-field="h2sPit" data-type="number" caption="H2S Pit" />
          <DxColumn data-field="nh3" data-type="number" caption="NH3" />
          <DxColumn data-field="blooieTemp" data-type="number" caption="BLOOIE Temp" />
          <DxColumn data-field="flowLineTemp" data-type="number" caption="Flow Line Temp" />
          <DxColumn data-field="mwdBht" data-type="number" caption="MWD BHT" />
          <DxColumn data-field="blooiePress" data-type="number" caption="BLOOIE Press" />
          <DxColumn data-field="mwdDhap" data-type="number" caption="MWD DHAP" />
          <DxColumn data-field="airDrilling" data-type="number" caption="Air Drilling" />
          <DxColumn data-field="foamCorrInhibitor" data-type="number" caption="Foam Corr Inhibitor" />
          <DxColumn data-field="airFluidRatio" data-type="number" caption="Air To Fluid Ratio" />
          <DxColumn data-field="mudLoss" data-type="number" caption="Mud Loss" />
          <DxColumn data-field="fluidReturn" data-type="number" caption="Fluid Return" />
          <DxColumn data-field="mudCooler" data-type="number" caption="Mud Cooler" />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import { formMethods, authComputed } from '@state/helpers'
import axios from 'axios'
import mapApiUrl from '@/src/utils/api-mapper'
import XLSX from 'xlsx'
import FileUpload from 'vue-upload-component'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxScrolling,
  DxSelection,
  DxButton as GridButton
  // DxFormItem
  // DxPopup,
  // DxLookup,
  // DxForm,
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import CustomStore from 'devextreme/data/custom_store'
import DxFileUploader from 'devextreme-vue/file-uploader'
import DxProgressBar from 'devextreme-vue/progress-bar'

const isNotEmpty = (value) => value !== undefined && value !== null && value !== ''

export default {
  components: {
    // ContigencyHeader, 
    FileUpload,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxScrolling,
    DxSelection,
    GridButton,
    // DxFormItem
    // DxPopup,
    // DxLookup,
    // DxForm,
    DxButton,
    DxProgressBar,
    DxFileUploader,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: undefined,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: undefined,
    },
    reportMap: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      rows: [],
      files: [],
      selectedRow: [],
      maxFileSize: 1024*1024,
      deleteRow: false,
      fileNameUpload: '',
      fileUpload: null,
      uploadsDataSource: null,
      drillingParametersDataSource: null,
      dataHasNotBeenUploaded: true,
      uploadClicked: false,
      uploadData: {jobStatus: 0},
    }
  },
  computed: {
    ...authComputed,
    uploadUrl() {
      return mapApiUrl('/api/form/master/drilling-parameters/upload')
    },
    uploadHeaders() {
      return {Authorization: `Bearer ${this.currentUser.token}`}
    },
    canEdit() {
      return this.dataHasNotBeenUploaded
      // return this.selectedRow.length > 0 && this.selectedRow[0].submitId === this.submitId
    }
  },
  watch: {
    submitId: function (value) {
      this.refreshDetailsGrid()
    },
    editable: function (val) {
      this.editableOps = val
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {      
      this.uploadsDataSource = new CustomStore({
        key: 'submitId',
        load: () => {
          const url = mapApiUrl('/api/form/master/drilling-parameters/get/forms')
          return axios.get(url, {params: {wellId: this.currentWell.wellId}})
               .then((response) => {
                 this.dataHasNotBeenUploaded = response.data.data.find(x => x.submitId === this.submitId) === undefined
                 if (!this.dataHasNotBeenUploaded) this.uploadData = response.data.data.find(x => x.submitId === this.submitId)
                 const temp = []
                 for (const data of response.data.data) {
                   const record = {...data}
                   const mapMatch = this.reportMap.find(x => x.submitId === record.submitId)
                   if (mapMatch !== undefined) {
                     record.no = mapMatch.index
                   }
                   temp.push(record)
                 }
                 return {data: temp, totalCount: temp.length}
                 })
                .catch(error => new Error(error.message)) 
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: undefined,
        update: undefined,
        remove: (key) => {
          const params = {}
          params.submitId = this.submitId
          params.uploadNo = key
          const url = mapApiUrl('/api/form/master/drilling-parameters/remove')
            return axios.delete(url, {params: params})
        },
      })
      this.drillingParametersDataSource = new CustomStore({
        key: 'id',
        load: (loadOptions) => {
            let params = {}
            params.submitId = this.submitId
            let options = [ 'filter', 'group', 'groupSummary', 'parentIds', 'requireGroupCount', 'requireTotalCount', 'searchExpr', 'searchOperation',
              'searchValue', 'select', 'sort', 'skip', 'take', 'totalSummary', 'userData'
            ]
            options.forEach(function(i) {
              if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                params[i] = loadOptions[i]
              }
            });
            const url = mapApiUrl('/api/form/master/drilling-parameters/list')
            return axios.get(url, {params: params})
               .then((response) => {
                 this.dataHasNotBeenUploaded = response.data.totalCount === 0
                 return response.data
                 })
               .catch(error => new Error(error.message)) 
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/drilling-parameters/add')
          return axios.post(url, values)
                      .then(response => {
                        this.dataHasNotBeenUploaded = false
                        return response
                      }) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/drilling-parameters/add')
          return axios.post(url, values).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/master/drilling-parameters/delete')
          return axios.delete(url, {params: {id: key, submitId: this.submitId}})
        },
      })
    },
    deleteAll() {
      const confirmed = confirm('Are you sure you want to clear all the data for this report? ','Confirmation')
        if (!confirmed) {
          return
        }
      let params = {}
      params.submitId = this.submitId
          const url = mapApiUrl('/api/form/master/drilling-parameters/remove')
            return axios.delete(url, {params: params})
           .then(response => {
             this.$refs.surveyGrid.instance.refresh()
           })
    },
    rowInserted() {
      notify({ message: 'Drilling parameter data row has been recorded.', width: 500 }, 'success', 3000)
    },
    rowUpdated() {
      notify({ message: 'Drilling parameter data row has been updated.', width: 500 }, 'success', 3000)
    },
    rowRemoved() {
      notify({ message: 'Drilling parameter data row has been removed.', width: 500 }, 'success', 3000)
    },
    onEditingStart(e) {
      const currentlyEditable = this.editable && this.submitId === e.data.submitId
      e.cancel = currentlyEditable
      if (e.cancel) {
        notify({ message: 'You can not change/remove other report.', width: 300 }, 'warning', 3000)
      }
    },
    refreshGrid() {
      this.$refs.reportGrid.instance.refresh()
    },
    refreshDetailsGrid() {
      this.$refs.reportDetailsGrid.instance.refresh()
    },
    setReportNo(rowData) {
      const match = this.reportMap.find(x => x.submitId === rowData.submitId)
      return match !== undefined ? match.index : ""
    },
    selectionChanged(e) {
      this.selectedRow = e.selectedRowsData
      this.refreshDetailsGrid()
    },
    startPeriodicTask() {
      // Call 'myTask' every 5000 milliseconds (5 seconds)
      this.pollingInterval = setInterval(() => {
        this.checkUpload();
      }, 5000);
    },
    checkUpload() {
      const url = mapApiUrl("/api/form/master/drilling-parameters/upload/monitor")
      this.uploadData = axios.get(url, {params: {id: this.uploadData.id}})
          .then(response => {
            if (response.data.data.jobStatus === 100) this.stopPeriodicTask()
            return response.data.data
          })
    },
    stopPeriodicTask() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },
    /* loadTextFromFile(ev) {
        const file = ev.target.files[0];
        const reader = new FileReader();

        reader.onload = e => {
            console.log("FileReader Success")
            const lines = e.target.result.split("\r\n")
            let linum = 0
            let startMillis = NaN
            let currentDate = new Date()
            let timeString = ""
            let lastHour = 0
            let hour = 0
            let startTime = performance.now()
            let row = []
            lines.forEach(element => {
                row = element.split(",")
                if (isNaN(startMillis)) {
                    startMillis = Date.parse(row[0])
                    if (isNumber(startMillis)) {
                        currentDate.setTime(startMillis)
                    }
                    lastHour = row[1].split(":").at(0)
                } 
                // console.log("Checkpoint 1 ", linum, row.length)
                if (isNumber(startMillis) && row.length>1) {
                    hour = row[1].split(":").at(0)
                    timeString = row[1]
                    if (hour < lastHour) {
                        currentDate.setDate(currentDate.getDate()+1)
                    }
                    // console.log("Checkpoint 2")
                    lastHour = hour
                    row[1] = currentDate.toLocaleDateString("zh-cn") + " " + timeString
                    row.shift()
                    if (row.length === "61") {
                        let nonBlanks=0
                        row.forEach(element => {
                            if (element.length>0) nonBlanks++ 
                        })
                        if (nonBlanks>0) this.rows.push(row)
                    }
                }
                linum++
            })
            let endTime = performance.now()
            console.log("Execution time : ",endTime-startTime)
            console.log("Processed lines :", linum)
            console.log("Acquired data:",this.rows.length)
            console.log("Sample : ", this.rows.at(this.rows.length/2))

        } 
      reader.readAsText(file);
    }, */
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile) {
        if (!oldFile) {
          // add
          // console.log('add', newFile.file.name)
        } else {
          // update
          // console.log('update', newFile)
        }
        let fileExceedsLimit = (newFile.size > this.maxFileSize) && (this.maxFileSize > 0)
        if (fileExceedsLimit) {
          // console.log("File size exceeds limit ",newFile.size,this.maxFileSize)
        }
        this.fileNameUpload = newFile.file.name
        this.fileUpload = newFile
      } else if (oldFile) {
        // remove
        // console.log('remove', oldFile)
      }
    },
    getAddress(row, col) {
        const letters="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        let colRemain = col
        let colLetters = ""
        while (colRemain > 0) {
          let divide = Math.floor(colRemain / 26)
          if (divide > 0) {
            colLetters += letters[divide]
            colRemain -= divide * 26
          }
          else
          {
            colLetters += letters[colRemain]
            colRemain = 0
          }
        }
        return colLetters + row
      },
    getCol(colLetters) {
        const letters="ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        let col = 0
        let mul = 1
        for (let i=colLetters.length-1; i >= 0; i--) {
          col += (letters.indexOf(colLetters[i])+1)*mul
          mul *= 26
        }
        return col
      },
      examineData(data) {
        this.workbook = XLSX.read(data, { type: 'binary' })
        if (this.workbook !== null) {
          this.sheet = this.workbook.Sheets[this.workbook.SheetNames[0]]
          let globalRange = this.sheet["!ref"].split(":")
          let maxCol = 0
          let i=0
          for (i=0; i<globalRange[1].length;i++) {
            if (!isNaN(globalRange[1][i])) break
          }
          maxCol = this.getCol(globalRange[1].substr(0,i))
          let maxRow = parseInt(globalRange[1].substr(i))
          console.log("globalRange, maxCol, maxRow", globalRange[1],maxCol,maxRow)
          let emptyRows = 0
          let emptyDepthRows = []
          let col = 3
          for (let row = 1; row<maxRow; row++) 
            // for (let col = 1; col<maxCol; col++)
            {
              let value = this.sheet[this.getAddress(row,col)]
              if (col === 3) {
                if (value === undefined) {
                  emptyDepthRows.push(row)
                  continue
                }
                let valueNumeric = value.v
                if (isNaN(valueNumeric) || valueNumeric < 0) {
                  emptyDepthRows.push(row)
                  continue
                }
                if (emptyDepthRows.length > 0 ) {
                  console.log("Some rows missing value of depth")
                  break
                }
              }
              if ( value === undefined) emptyRows++
          }
          if (emptyDepthRows.length === maxRow) {
            console.log("All rows have no value of depth")
          }
          console.log("Empty rows",emptyRows)
        }
      },
    submitFile() {
      this.uploadClicked = true
      let formData = new FormData()

      formData.append('submitId', this.submitId)
      formData.append('files', this.files[0].file)
      // console.log(formData)
      const url = mapApiUrl('/api/form/master/drilling-parameters/upload')
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          // console.log('response ', response)
          this.fileUpload = null
          this.selectedRow = []
          this.uploadClicked = false
          this.uploadData = {...response.data.data}
          // this.startPeriodicTask()
          this.refreshGrid()
        })
    },
    uploadClick() {
      this.$refs.fileUploader.load()
    },
    handleFileUpload() {
      this.fileUpload = this.$refs.formfile.files[0]
    },
    downloadContigencyTemplate() {
      // const url = mapApiUrl('/api/form/report/templates/download/ddr?formType=drilling_parameters')
      const url = mapApiUrl('/api/form/master/drilling-parameters/download')
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'drilling_parameters_form_template.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    createColDef() {
      this.columnDefinition = [
        {column:1, name:'Date', type:'Date', allowEmpty:true, defaultValue:''},
        {column:2, name:'Time', type:'Time', allowEmpty:true, defaultValue:''},
        {column:3, name:'Depth', type:'Numeric', allowEmpty:false, defaultValue:''},
        {column:4, name:'TVD', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:5, name:'ROP', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:6, name:'ROP Min', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:7, name:'ROP Max', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:8, name:'WOB', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:9, name:'WOB Min', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:10, name:'WOB Max', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:11, name:'WOH', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:12, name:'HK Height', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:13, name:'RPM', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:14, name:'DH RPM', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:15, name:'Total RPM', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:16, name:'Flow In', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:17, name:'Flow In Min', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:18, name:'Flow In Max', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:19, name:'Pump 1', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:20, name:'Pump 2', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:21, name:'Pump 3', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:22, name:'Total Pump', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:23, name:'SPP', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:24, name:'SPP Min', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:25, name:'SPP Max', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:26, name:'Torque', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:27, name:'Torque Min', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:28, name:'Torque Max', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:29, name:'Returns ', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:30, name:'Ada Return', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:31, name:'Temp In', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:32, name:'Temp Out', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:33, name:'MW In', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:34, name:'MW Out', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:35, name:'Cond In', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:36, name:'Cond Out', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:37, name:'Interm 1', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:38, name:'Interm 2', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:39, name:'Active', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:40, name:'Reserve-1', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:41, name:'Sum Active', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:42, name:'HK Height', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:43, name:'Bit Time', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:44, name:'Pump Time', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:45, name:'Rev on Bottom', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:46, name:'CO2', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:47, name:'H2S Line', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:48, name:'H2S Shaker', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:49, name:'H2S Pit', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:50, name:'NH 3', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:51, name:'BLOOIE Temp', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:52, name:'Flow Line Temp', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:53, name:'MWD BHT', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:54, name:'DH RPM', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:55, name:'BLOOIE Press', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:56, name:'MWD DHAP', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:57, name:'Air Drilling', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:58, name:'Foam + COR Inhibitor', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:59, name:'Air Fluid Ratio', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:60, name:'Mud Loss', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:61, name:'Fluid Return', type:'Numeric', allowEmpty:true, defaultValue:''},
        {column:62, name:'Mud Cooler', type:'String', allowEmpty:true, defaultValue:''},]
    },
  }
}
</script>
